<template>
  <div>
    <el-form
      class="mt-2"
      ref="form"
      :model="formData"
      :disabled="disabled"
      :rules="rules"
      size="mini"
      label-width="130px"
      label-position="left"
    >
      <div class="el-form-row">
        <el-form-item
          :label="$l('form_label_linkUser') || '收件人'"
          prop="linkUserCodes"
        >
          <dict-select
            v-model="formData.linkUserCodes"
            url="/master/common/dict/baseUserSelect"
            :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
            clearable
            filterable
            multiple
          />
        </el-form-item>
      </div>
      <div class="el-form-row">
        <el-form-item
          :label="$l('form_label_remark_info') || '信息内容'"
          prop="remark"
        >
          <TopicsEditor
            v-model="formData.remark"
            @updateText="onUpdateText"
            :disabled="disabled"
          />
        </el-form-item>
      </div>
      <div class="el-form-row">
        <div class="el-form-item el-form-item--mini" style="height: 210px">
          <div class="el-form-item__label" style="width: 130px">
            {{ $l('tips_task_doc') || '任务附件' }}
            <div class="mt-2">
              <el-button
                class="button_info fws"
                type="primary"
                size="mini"
                @click.stop="uploadTskFile"
              >
                <span>
                  {{ $l('btn_uploadTaskDoc') || '上传任务附件' }}
                </span>
              </el-button>
            </div>
          </div>
          <div
            class="el-form-item__content"
            style="padding: 10px; margin-left: 130px"
          >
            <TaskDoc
              ref="taskDoc"
              :key="'taskDoc'"
              :tskInfoCode="tskInfoCode"
              :tskRemarkCode="newTskRemarkCode"
              :expoMeetingCode="expoMeetingCode"
              :customStyle="`height:190px;overflow: auto;`"
            ></TaskDoc>
          </div>
        </div>
      </div>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import TopicsEditor from '../../../../components/topics-editor'
import TaskDoc from '../task-doc'
import dayjs from 'dayjs'
export default {
  mixins: [EditLoading],
  components: {
    TopicsEditor,
    TaskDoc,
  },
  props: {
    disabled: { type: Boolean, default: false },
    tskRemarkCode: { type: String, default: '' },
    expoMeetingCode: { type: String, default: '' },
    tskInfoCode: { type: String, default: '' },
    linkUserCodes: { type: Array, default: [] },
  },
  watch: {
    linkUserCodes: {
      handler() {
        this.formData.linkUserCodes = this.linkUserCodes
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      formData: {
        linkUserCodes: [],
      },
      valueChangeFlag: false,
      initData: {},
      backDialogVisible: false,
      rules: {
        remark: [{ trigger: 'blur', required: true, message: ' ' }],
        linkUserCodes: [{ trigger: 'change', required: true, message: ' ' }],
      },
    }
  },
  computed: {
    newTskRemarkCode() {
      return this.tskRemarkCode || this.formData.tskRemarkCode
    },
  },
  async mounted() {
    await this.getData('')
  },
  methods: {
    async uploadTskFile() {
      let res = true
      if (!this.newTskRemarkCode) {
        res = await this.save(false)
      }
      if (res) {
        this.$refs.taskDoc.uploadFile()
      }
    },
    async getData(code = '') {
      if (!this.tskRemarkCode && !code) return
      const res = await this.$api
        .personalTskRemarkDetailApi({
          tskRemarkCode: this.tskRemarkCode || code,
        })
        .catch(() => null)
      if (!res) return
      this.formData = res.body
      this.initData = Object.assign({}, res.body || {})
      setTimeout(() => {
        this.$refs.form.clearValidate()
      }, 0)
    },
    checkValueChange() {
      const oldRemarkText = (this.initData.remarkText || '').trim()
      const remarkText = (this.formData.remarkText || '').trim()
      this.valueChangeFlag =
        oldRemarkText == remarkText &&
        JSON.stringify(this.initData.linkUserCodes) ==
          JSON.stringify(this.formData.linkUserCodes)
    },
    onUpdateText(text) {
      this.formData.remarkText = text
    },
    async save(showNotify = true) {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        this.backDialogVisible = false
        return false
      }

      if (this.loadingOpen()) return
      const res = await this.$api
        .personalTskRemarkSaveApi({
          ...this.formData,
          tskInfoCode: this.tskInfoCode,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return false
      const { status, body } = res
      if (status !== 200) {
        this.backDialogVisible = false
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return false
      }
      if (showNotify) {
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_save_ok') || '保存成功！',
          type: 'success',
        })
      }
      this.backDialogVisible = false
      this.getData(body)
      this.$emit('reload')
      return true
    },
    cancel() {
      this.checkValueChange()
      if (this.disabled) {
        this.close()
        return
      }
      if (!this.valueChangeFlag) {
        this.backDialogVisible = true
      } else {
        this.close()
        return
      }
    },
    close() {
      this.valueChangeFlag = false
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .border-top-none {
    .el-descriptions-item__label,
    .el-descriptions-item__content {
      border-top: none !important;
    }
  }

  .el-form {
    .el-form-row {
      display: flex;
      border: 1px solid #ebeef5;
      border-top: none;
      border-left: none;
      .tag-ifno {
        .el-form-item__content {
          height: 100%;
          display: flex;
          align-items: center;
        }
      }
      .el-form-item {
        margin: 0 !important;
        position: relative;
        width: 100%;

        .el-form-item__label {
          color: #909399;
          background: #fafafa;
          box-sizing: border-box;
          text-align: left;
          font-weight: 400;
          line-height: 1.5;
          padding: 8px 10px;
          border-left: 1px solid #ebeef5;
          border-right: 1px solid #ebeef5;
          font-size: 12px !important;
          position: absolute;
          bottom: 0;
          top: 0;
        }

        .el-form-item__content {
          padding: 0 5px;
          box-sizing: border-box;
          text-align: left;
          font-weight: 400;
          line-height: 1.5;
          color: #606266;
          font-size: 12px !important;
          > div {
            margin: 3.2px 0;
          }
          > .el-input {
            input[readonly] {
              border: none;
              background-color: #fff;
              color: #606266;
              cursor: auto;
            }
          }
          .el-input-number .el-input__inner {
            text-align: left;
          }
          .no-error {
            .el-input__inner {
              border-color: #dcdfe6 !important;
            }
          }
          .el-range-input {
            width: 34%;
          }
          .el-range-separator {
            width: 11%;
            color: #606266;
          }

          .el-date-editor .el-input__inner {
            text-align: center;
          }
        }
      }
    }

    > div:first-child {
      border-top: 1px solid #ebeef5;
    }
  }
}
.button_info {
  background-color: #18c5bd;
  border: none;
}
.fws {
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 14px;
}
.drawer-footer {
  padding: 10px 30px 30px;
  display: flex;
  justify-content: flex-end;
}
</style>
